// extracted by css-extract-rspack-plugin
export default {"item":"_659c8c42","summary":"_23c49e9b","summarySmall":"_693d0c84","summaryMedium":"_b4fae3e6","details":"_2f088c95","chevron":"_3ef6f77c"};